import { render, staticRenderFns } from "./CommentAttributeRenderer.vue?vue&type=template&id=680c0e27"
import script from "./CommentAttributeRenderer.vue?vue&type=script&lang=js"
export * from "./CommentAttributeRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports